import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import { withRouter } from "react-router"

import { event } from "../components/reactGA"
import config from "../Config"
import PrimaryButton from "../components/buttons/PrimaryButton"
import { I18nContext } from "react-i18next"
import i18n from "./../i18n"

import { fetchData, removeData } from "../store/action"
import Cookie from "../util/Cookie"
import isEmpty from "lodash/isEmpty"
import Storage from "../util/Storage"

const Container = styled.div`
  color: #fff;
  width: 85%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Text = styled.span`
  font-size: 16px;
`

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      header: "",
    }
    this.handleInvite = this.handleInvite.bind(this)
    this.userProfileData = this.userProfileData.bind(this)
  }

  componentWillMount() {
    if (Cookie.get("X-Reycreo-Auth-Token")) {
      this.userProfileData()
    }
  }

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
  }

  handleInvite() {
    this.props.history.push("/play/invite-and-earn")
    event({
      category: "Home Page",
      action: "Free Bids",
    })
  }

  userProfileData() {
    const { fetchData, uniqueId } = this.props

    fetchData({
      uniqueId,
      noLoading: true,
      method: "GET",
      uri: `/userProfile`,
      onSuccess: (freshUser) => {
        if (!freshUser.contactNumber) {
          const userId = Cookie.get("X-Reycreo-Id")
          const msisdn = userId.split("BW_PH")
          freshUser.contactNumber = !isEmpty(msisdn[1]) && msisdn[1]
        }
        console.log("freshUser", freshUser)
        this.setState({ ...freshUser })
        Storage.set("userImage", freshUser.imageUrl)
      },
    })
  }

  render() {
    const { headerTitle, freeBids } = this.props

    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    console.log(" SUB APP Timer ", subDomain)
    let flagVid = false
    if (subDomain === "epu") {
      flagVid = true
    }
    return (
      <Container>
        {headerTitle ? (
          <Text className='montserratSemiBold'>{headerTitle}</Text>
        ) : (
          // <img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/bidnwin_Logo.svg`}/>
          <Text className='montserratRegular'>Bidnwin</Text>
        )}
        {flagVid && (
          <a href='https://youtu.be/lkNJaqqkyKY' target='_blank'>
            <img
              src={`https://d3e4gbj075migb.cloudfront.net/fanmoby-static/como_jugar.png`}
              style={{
                width: 120,
                height: 35,
                marginTop: 2,
                marginBottom: -2,
                marginRight: 1,
                marginLeft: 1,
              }}
            />
          </a>
        )}

        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            marginRight: "5px",
            cursor: "pointer",
          }}
          onClick={() => this.props.history.push("/play/my-account")}
        >
          {this.state.imageUrl ? (
            <img
              src={this.state.imageUrl}
              style={{ width: "100%", height: "100%", borderRadius: "50%" }}
            />
          ) : (
            <img
              src={`${
                config.BIDNWIN_S3_IMAGE_URL_NEW_UI
              }/side-menu-icons/user-profile.png`}
              style={{ width: "100%", height: "100%", borderRadius: "50%" }}
            />
          )}
        </div>

        {/* {freeBids && (
          <PrimaryButton
            label={i18n.t("FreeBids")}
            variant='contained'
            style={{
              minWidth: "100px",
              color: "#fff",
              marginRight: 10,
              borderRadius: 8,
            }}
            onClick={this.handleInvite}
          />
        )} */}
      </Container>
    )
  }
}

Header.defaultProps = {
  freeBids: false,
}

export default (Header = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      mapStateToProps.data = state.data[ownProps.uniqueId]
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
  }
)(withRouter(Header)))



// WEBPACK FOOTER //
// ./src/views/Header.js